import React from 'react'
import { Breadcrumb } from 'antd';
import { connect } from "react-redux";
import actionWays from '../../../redux/actions.js';
import Top from '../Top'
import Footer from '../Footer.js'
import './requestConditions.scss'
class RequestConditions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabData: [],
            loading: false,
            rawHTML: '',
            rightTitle: '',
            downLoadList: [],
        }
    }
    componentDidMount() {
        this.setState({
            loading: true,
        })
    }
    render() {
        const { loading } = this.state;
        return (
            <div id={'requestConditions'} style={{ background: '#fff' }}>
                <Top />
                {loading ? <div>
                    <div className='requestConditions_top'></div>
                    <div className="col-lg-3"></div>
                    <div className="col-lg-6">
                        <div style={{ paddingLeft: '7px', margin: '1em 0' }}>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>首页</Breadcrumb.Item>
                                <Breadcrumb.Item>申请条件</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <div className='requestConditions_box'>
                            <div className='rcBox_top'>
                                <p className='rcBox_top_title'>公共租赁住房申请条件</p>
                                <p className='rcBox_top_content'>
                                    <span>申请本区公共租赁住房准入资格的申请人应当符合以下标准之一：</span>
                                    <br />
                                    1.具有本市常住户口，且与本区就业单位签订一年以上(含一年)劳动合同,并依法缴纳各项社会保险金;
                                    <br />
                                    2.具有本区常住户口，且与本市就业单位签订一年以上(含一年)劳动合同,并依法缴纳各项社会保险金;
                                    <br />
                                    3.持有有效期内《上海市居住证》，与本区单位签订一年以上(含一年)劳动合同,并依法缴纳各项社会保险金。
                                    <br />
                                    <span>申请本区公共租赁住房准入资格的单身申请人或申请家庭全体成员应当同时符合以下条件:</span>
                                    <br />
                                    1.在本区无自有住房或人均住房建筑面积低于15平方米,因结婚分室居住有困难的,人均面积可适当放宽;
                                    <br />
                                    2.申请时，未享受本市其他保障住房政策。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3"></div>
                    <Footer />
                </div> : ''}
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(RequestConditions)
